import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Collapse,
  Chip,
  Card,
  TableSortLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as AddIcon } from "../../Assets/Icons/PharmsmartIcon/AddIcon.svg";
import { ReactComponent as CollaspseOpen } from "../../Assets/Icons/PharmsmartIcon/CollaspseOpen.svg";
import { ReactComponent as CollaspseClose } from "../../Assets/Icons/PharmsmartIcon/CollaspseClose.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as NursingIcone } from "../../Assets/Icons/nursing.svg";
import { ReactComponent as AddPersonMainIcon } from "../../Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import { ReactComponent as ViewRxIcon } from "../../Assets/Icons/PharmsmartIcon/ViewRxIcon.svg";
import GroupEmptyState from "../../Components/Common/GroupEmptyState";
import GroupLoader from "../../Components/Common/GroupLoader";
import _ from "underscore";
import "../../Sass/Common.scss";
import {
  capitalizeFirstLetter,
  setLocalStorage,
} from "../../utils/generalUtils";
import { visuallyHidden } from "@mui/utils";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import moment from "moment";
import useViewport from "../../Hooks/useViewport";
const useStyle = makeStyles((theme) => ({
  groupNameGrid: {
    background: theme.palette.background.paper,
    boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.1)",
    padding: "5px 11px 5px",
    borderRadius: "4px",
    marginBottom: "5px !important",
    position: "relative",
    "&>div": {
      "&>div": {
        "&>button": {
          "&>svg": {
            "&>path": {
              fill: "transparent",
            },
          },
        },
      },
    },
  },
  rsPatientGridOne: {
    display: "flex",
    justifyContent: "start",
    // paddingLeft: "15px",
    // marginLeft: "-10px",
    // position: "sticky",
    // // top: "-24px",
    // top: "0px",
    // // background: "white",
    // zIndex: "10",
    // paddingTop: "30px",
  },
  groupNameGridMain: {
    background: theme.palette.background.paper,
    boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.1)",
    padding: "5px 11px 5px",
    borderRadius: "4px",

    margin: "5px",
    marginLeft: "10px !important",
    marginBottom: "5px !important",
    marginTop: "5px !important",

    position: "relative",
    width: "auto",
    minWidth: "auto",
    height: "98px",
    borderRadius: "14px",
    cursor: "pointer",
    "&>div": {
      "&>div": {
        marginTop: "-2px",
        "&>div": {
          "&>button": {
            "&>svg": {
              "&>path": {
                fill: "transparent",
              },
            },
          },
        },
      },
    },
    // [theme.breakpoints.down("1850")]: {
    //   margin: "5px",
    //   marginLeft: "10px",
    // },
    // [theme.breakpoints.down("1470")]: {
    //   width: "auto",
    //   minWidth: "200px",
    // },
    // [theme.breakpoints.down("1380")]: {
    //   width: "auto",
    //   minWidth: "200px",
    // },
    // [theme.breakpoints.down("1270")]: {
    //   width: "auto",
    //   minWidth: "100px",
    // },
    // [theme.breakpoints.down("1250")]: {
    //   width: "auto",
    //   minWidth: "230px",
    // },
    // [theme.breakpoints.down("1200")]: {
    //   width: "auto",
    //   minWidth: "250px",
    // },
  },
  addPatientBtn: {
    height: "37px !important",
    float: "right",
    marginBottom: "20px !important",
    marginTop: "16px !important",
    marginRight: "10px !important",
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    padding: "0",
  },
  managePageH: {
    maxHeight: "calc(100vh - 174px)",
    overflow: "auto",
  },
  statusText: {
    border: "none !important",
    borderRadius: "10px !important",
    fontSize: "10px !important",
    height: "20px !important",
    marginLeft: "10px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white !important",
    display: "flex",
    alignItems: "center",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px",
    },
  },
  groupColorIcon: {
    padding: "10px",
    margin: "8px",
    borderRadius: "3px !important",
  },
  ColorStripe: {
    top: "-3px",
    left: "-10px",
    // padding: "10px",
    position: "absolute",
    // margin: "-8px",
    borderRadius: "14px 0px 0px 14px !important",
    height: "98px",
    width: "12px",
  },
  rsGroupTotalPatientCount: {
    // cursor: "pointer",
    margin: "8px",
  },
  rsGroupName: {
    cursor: "pointer",
  },
  tableSort: {
    // color: "#5A6872 !important",
    flexDirection: "row",
    "& .MuiTableSortLabel-icon": {
      opacity: 1,
    },
    "& .MuiTableSortLabel-root.MuiTableSortLabel-active": {
      color: theme.palette.background.red,
    },
  },
  rsPatientName: {
    display: "inline-flex",
    alignItems: "center",
    // display: "block !important",
  },
  rsNextOrderDate: {
    display: "flex",
    justifyContent: "flex-end",
  },
  rsOrderDateText: {
    display: "flex",
    alignItems: "center",
    color: "#5A6872",
    "&>button": {
      marginLeft: "8px",
    },
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    // padding: "10px 5px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    // marginRight: "10px !important",
    "&>svg": {
      height: "19px",
      "&>path": {
        // fill: "white !important",
        stroke: "black !important",
      },
    },
  },
  hoverAlign: {
    padding: "10px 6px !important",
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        borderWidth: "1px 0px 1px 1px !important",
        borderBottom: "0px solid #F7F7F8 !important",
      },
    },
  },
  tableHead: {
    "&>tr": {
      "&>th": {
        padding: "11px 16px",
        // lineHeight: "1rem",
        // "&>span":{
        //   color:"white !important",
        // },
        // borderWidth: "1px 0px 1px 1px !important",
        borderWidth: "0px 0px 3px 3px !important",
      },
    },
  },
  rsGroupNamemain: {
    paddingLeft: "10px !important",
    paddingTop: "5px !important",
    // lineHeight: "18px !important",
    "&:hover": {
      cursor: "pointer",
      color: "rgba(90, 104, 114, 0.95) !important",
      // textDecoration: "underline",
      // fontWeight: "600 !important",
      // fontSize: "18px !important",
      // transition: "0.5s !important",
    },
  },
  testEmpty: {
    marginLeft: "15px",
  },
  grpTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "&>div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "35px",
      width: "36px",
      borderRadius: "5px",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.04)",
      },
      "&>svg": {
        "&>line": {
          stroke: "#000",
          strokeWidth: "1.6px",
          strokeLinecap: "butt",
        },
        "&>path": {
          fill: "transparent",
          stroke: "#000",
          strokeWidth: "1.6px",
        },
      },
    },
  },
}));

/** head title */
const headCells = [
  {
    id: "name",
    label: "NAME",
    sortable: true,
    numeric: false,
  },
];
const GroupTable = ({
  groupList,
  handleOpen,
  setGroupRecordActionType,
  setEditGroupData,
  setIsOpenGroupModel,
  setGroupRecordDeleteActionType,
  setDeleteGroup,
  setGroupDeleteId,
  isOpenCollapse,
  setSelectedPatientId,
  setTarget,
  collapseOpen,
  setCollapseOpen,
  collapseIndex,
  setCollapseIndex,
  showDataBasedOnRole,
  setPatientDetailOpen,
  setPatientId,
  isOpenNextOrderDate,
  setIsOpenNextOrderDate,
  groupDailogOpen,
  setGroupDailogOpen,
  groupData,
  setGroupData,
}) => {
  const classes = useStyle();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [orderBtn, setOrderBtn] = React.useState(false);
  let { width } = useViewport();
  /* Handle Sort Column */
  const handleRequestSort = (event, property, item, i) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");

    setOrderBy(property);
    setOrderBtn(true);
    if (isAsc === true) {
      item?.patient_info.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
      );
    } else {
      item?.patient_info.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
    }
  };

  /* Create Sort Handler */
  const createSortHandler = (property, i, item) => (event) => {
    handleRequestSort(event, property, item, i);
  };

  /* Group List Map */
  useEffect(() => {
    groupList?.data?.list?.map((item, i) => {
      if (groupList?.data?.list.length > collapseIndex && collapseIndex >= 0) {
        if (collapseOpen) {
          handleOpen(0);
        } else if (collapseIndex === 1) {
          handleOpen(0);
        }
        handleOpen(collapseIndex);
      } else {
        setCollapseIndex(0);
        setCollapseOpen(true);
      }
    });
  }, [collapseOpen, collapseIndex, groupList]);

  return (
    <>
      <Grid className={classes.managePageH}>
        <Grid
          // container
          container
          // spacing={{ xs: 2, sm: 1, md: 3, lg: 3 }}
          // columns={{ xs: 1, sm: 4, md: 20, lg: 20 }}
          // columnSpacing={2.5}
          // rowSpacing={1.5}
          // columnSpacing={1}
          // rowSpacing={2}
          className={classes.rsPatientGridOne}
          // id={"error"}
        >
          {groupList?.loading ? (
            <GroupLoader cells={7} rows={4} />
          ) : // <TableCellLoader cells={18} rows={18} />
          groupList?.data?.list?.length > 0 ? (
            groupList?.data?.list?.map((item, i) => {
              return (
                <>
                  <Grid
                    // xs: 0,
                    // sm: 600,
                    // md: 900,
                    // lg: 1200,
                    // xl: 1536,
                    xs={width < 600 && width >= 500 ? 5.7 : 12}
                    sm={
                      // width < 800 && width >= 610
                      // ? 5.8
                      // : width < 610
                      // ? 5.7
                      // : 5.7
                      width < 800 && width >= 768 ? 7 : width < 610 ? 5.7 : 5.7
                    }
                    md={width < 1060 ? 5.7 : 3.8}
                    lg={3.8}
                    xl={2.9}
                    key={i}
                    item
                    className={classes.groupNameGridMain}
                    onClick={() => {
                      setGroupDailogOpen(true);
                      setGroupData(item);
                      handleOpen(i);
                    }}
                  >
                    {/* <Grid xs={8} className={classes.groupNameGrid} key={i}> */}
                    {/* <Grid xs={8} className={classes.groupNameGridMain} key={i}> */}
                    {/* <Box display={"flex"} justifyContent={"space-between"}> */}
                    <Box>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        position={"relative"}
                        onClick={() => {
                          handleOpen(i);
                        }}
                      >
                        <Card
                          className={classes.ColorStripe}
                          style={{ background: item?.g_color_code }}
                        />
                        <Box className={classes.grpTitleContainer}>
                          <Typography
                            variant="h4"
                            semiBold
                            color={"#262626"}
                            className={classes.rsGroupNamemain}
                            onClick={() => {
                              setGroupDailogOpen(true);
                              setGroupData(item);
                            }}
                          >
                            {capitalizeFirstLetter(item?.g_name)}
                          </Typography>
                          <HtmlTooltipMain title="Group details">
                            <Box>
                              <PrimaryIcon
                                height="21px"
                                icon={ViewRxIcon}
                                cursor="pointer"
                              />
                            </Box>
                          </HtmlTooltipMain>
                        </Box>
                      </Box>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        paddingLeft={"10px"}
                        paddingTop={"7px"}
                        // onClick={() => handleOpen(i)}
                      >
                        <Typography
                          // variant="h4"
                          variant="h6"
                          className={classes.rsGroupTotalPatientCount}
                          onClick={() => {
                            setGroupDailogOpen(true);
                            setGroupData(item);
                            handleOpen(i);
                          }}
                          color={"#595959"}
                        >
                          Total Patients
                          {/* ({item?.patient_count}) */}
                        </Typography>

                        {/* <IconButton onClick={() => handleOpen(i)}>
                        <PrimaryIcon
                          height="19px"
                          icon={
                            isOpenCollapse === i
                              ? CollaspseOpen
                              : CollaspseClose
                          }
                          cursor={"pointer"}
                        />
                      </IconButton> */}
                      </Box>
                      <Box
                        display={"flex"}
                        paddingLeft={"10px"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <Typography
                          // variant="h4"
                          variant="h3"
                          medium
                          className={classes.rsGroupTotalPatientCount}
                          onClick={() => handleOpen(i)}
                          color={"#595959"}
                        >
                          {/* Total Patients */}
                          {item?.patient_count}
                        </Typography>
                        <Box marginTop={"-5px"}>
                          {showDataBasedOnRole !== "user" && (
                            <HtmlTooltipMain
                              title="Add Patient"
                              className={classes.hoverAlign}
                            >
                              <IconButton
                                className={classes.rsButtonHowtoIcon}
                                variant="contained"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setGroupRecordActionType("addPatientInGroup");
                                  setEditGroupData(item);
                                  setIsOpenGroupModel(true);
                                  setLocalStorage("group_name", item.g_name);
                                }}
                              >
                                <PrimaryIcon
                                  height="19  px"
                                  icon={AddPersonMainIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                          )}
                          {showDataBasedOnRole !== "user" && (
                            <HtmlTooltipMain title="Edit Group">
                              <IconButton
                                className={classes.rsButtonHowtoIcon}
                                // className={classes.hoverAlign}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setGroupRecordActionType("editGroupDetail");
                                  setEditGroupData(item);
                                  setIsOpenGroupModel(true);
                                }}
                              >
                                <PrimaryIcon
                                  color="secondary"
                                  width="20px"
                                  icon={EditIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                          )}
                          {showDataBasedOnRole !== "user" &&
                            item?.g_is_nursing_allowed && (
                              <HtmlTooltipMain title="Nursing Home">
                                <IconButton
                                  className={classes.rsButtonHowtoIcon}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <PrimaryIcon
                                    height="19px"
                                    icon={NursingIcone}
                                    cursor="pointer"
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                            )}
                          {showDataBasedOnRole !== "user" && (
                            <HtmlTooltipMain title="Delete Group">
                              <IconButton
                                className={classes.rsButtonHowtoIcon}
                                // className={classes.hoverAlign}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setGroupRecordDeleteActionType("groupDelete");
                                  setDeleteGroup(true);
                                  setGroupDeleteId(item?.g_id);
                                }}
                              >
                                <PrimaryIcon
                                  height="19px"
                                  icon={DeleteIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    {/* </Grid> */}
                    {/* <Collapse
                  in={isOpenCollapse === i}
                  timeout="auto"
                  unmountOnExit
                >
                  <Grid className="common-table group-table-wrapper"> */}
                    {/* <TableContainer
                      className={classes.tableContainer}
                      style={{
                        marginTop: isOpenCollapse === i ? "-9px" : "0",
                        // marginTop: isOpenCollapse === i ? "-19px" : "0",
                      }}
                    > */}
                    {/* <Box className={classes.rsNextOrderDate}> */}
                    {/* <Box className={classes.rsOrderDateText}>
                          Next order date:{" "}
                          {item?.gnod_order_date
                            ? moment(new Date(item?.gnod_order_date)).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}{" "}
                          {showDataBasedOnRole !== "user" && (
                            <IconButton
                              className={classes.hoverAlign}
                              onClick={() => {
                                setGroupRecordActionType("editGroupDetail");
                                setEditGroupData(item);
                                setIsOpenNextOrderDate(true);
                              }}
                            >
                              <PrimaryIcon
                                icon={EditIcon}
                                color="white"
                                width="20px"
                                height="20px"
                              />
                            </IconButton>
                          )}
                        </Box> */}
                    {/* {showDataBasedOnRole !== "user" && (
                          <Button
                            variant="contained"
                            onClick={() => {
                              setGroupRecordActionType("addPatientInGroup");
                              setEditGroupData(item);
                              setIsOpenGroupModel(true);
                              setLocalStorage("group_name", item.g_name);
                            }}
                            className={classes.addPatientBtn}
                            startIcon={
                              <PrimaryIcon
                                icon={AddIcon}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                          >
                            Add Patient
                          </Button>
                        )} */}
                    {/* </Box> */}
                    {/* <Table stickyHeader> */}
                    {/* <TableHead className={classes.tableHead}>
                          <TableRow> */}
                    {/* {headCells.map((headCell) => (
                              <>
                                {headCell.sortable === true ? (
                                  <TableCell
                                    key={headCell.id}
                                    align={headCell.numeric ? "right" : "left"}
                                    padding={
                                      headCell.disablePadding
                                        ? "none"
                                        : "normal"
                                    }
                                    sortDirection={
                                      orderBy === headCell.id ? order : false
                                    }
                                  >
                                    <TableSortLabel
                                      sx={{
                                        "&.MuiTableSortLabel-root": {
                                          color: "white",
                                        },
                                        "& .MuiTableSortLabel-icon": {
                                          color:
                                            orderBtn === true && headCell.id
                                              ? "#525252 !important"
                                              : "#C5C5C5 !important",
                                          "&.MuiTableSortLabel-iconDirectionDesc":
                                            {
                                              color: "#525252 !important",
                                            },
                                          "& .MuiTableSortLabel-iconDirectionAsc":
                                            {
                                              color:
                                                orderBtn === true && headCell.id
                                                  ? "#525252 !important"
                                                  : "#C5C5C5 !important",
                                            },
                                        },
                                      }}
                                      className={classes.tableSort}
                                      active={orderBy === headCell.id}
                                      direction={
                                        orderBy === headCell.id ? order : "asc"
                                      }
                                      onClick={createSortHandler(
                                        headCell.id,
                                        i,
                                        item
                                      )}
                                    >
                                      {headCell.label}
                                      {orderBy === headCell.id ? (
                                        <Box
                                          component="span"
                                          sx={visuallyHidden}
                                        >
                                          {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                        </Box>
                                      ) : null}
                                    </TableSortLabel>
                                  </TableCell>
                                ) : (
                                  <TableCell> {headCell.label}</TableCell>
                                )}
                              </>
                            ))} */}
                    {/* {/* <TableCell>NAME</TableCell> */}
                    {/* {showDataBasedOnRole !== "user" && (
                              <TableCell>ACTIONS</TableCell>
                            )}
                          </TableRow>
                        </TableHead> */}
                    {/* <TableBody className={classes.tableBody}>
                          {groupList?.loading ? (
                            <TableCellLoader cells={3} />
                          ) : item?.patient_info?.length > 0 ? (
                            item?.patient_info?.map((patientList, index) => {
                              return (
                                <TableRow>
                                  <TableCell semiBold>
                                    <Box
                                      display={"flex"}
                                      className={classes.rsPatientName}
                                    >
                                      <Box
                                        className="cursor-pointer"
                                        onClick={(event) => {
                                          // setDetailsDialog(true);
                                          // setPatientDetails(item);
                                          setPatientId(patientList?.pg_pi_id);
                                          setPatientDetailOpen(true);
                                        }}
                                      >
                                        {patientList?.name}
                                        {` `}
                                        {patientList?.last_name}
                                      </Box>
                                      {item?.status !== "Active" && (
                                        <Chip
                                          label={
                                            patientList?.status === "Active"
                                              ? null
                                              : patientList?.status
                                          }
                                          variant="outlined"
                                          className={classes.statusText}
                                          style={{
                                            backgroundColor: (() => {
                                              if (
                                                patientList?.status === "Absent"
                                              ) {
                                                return "rgba(107, 107, 107,0.6)";
                                              } else if (
                                                patientList?.status ===
                                                "In-Hospital"
                                              ) {
                                                return "rgba(210, 162, 68,0.6)";
                                              } else if (
                                                patientList?.status ===
                                                "Deceased"
                                              ) {
                                                return "rgba(255, 0, 0,0.6)";
                                              }
                                            })(),
                                            color: (() => {
                                              if (
                                                patientList?.status === "Absent"
                                              ) {
                                                return "white";
                                              } else if (
                                                patientList?.status ===
                                                "In-Hospital"
                                              ) {
                                                return "white";
                                              } else {
                                                return "white";
                                              }
                                            })(),
                                          }}
                                        />
                                      )}
                                    </Box>
                                  </TableCell>
                                  {showDataBasedOnRole !== "user" && (
                                    <TableCell>
                                      <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                      >
                                        <HtmlTooltipMain title="Remove Patient">
                                          <IconButton
                                            className={classes.hoverAlign}
                                            onClick={() => {
                                              setGroupRecordDeleteActionType(
                                                "patientDelete"
                                              );
                                              setEditGroupData(item);
                                              setDeleteGroup(true);
                                              setGroupDeleteId(item?.g_id);
                                              setSelectedPatientId(
                                                patientList?.pg_pi_id
                                              );
                                            }}
                                          >
                                            <PrimaryIcon
                                              height="19px"
                                              icon={DeleteIcon}
                                              cursor="pointer"
                                            />
                                          </IconButton>
                                        </HtmlTooltipMain>
                                      </Box>
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableEmptyState />
                          )}
                        </TableBody> */}
                    {/* </Table>
                    </TableContainer> */}
                    {/* </Grid>
                </Collapse> */}{" "}
                  </Grid>
                </>
              );
            })
          ) : (
            <Box className={classes.testEmpty}>
              <GroupEmptyState />
            </Box>
          )}
          {groupList?.data?.list?.length !==
            groupList?.data?.filterd_record && (
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <TableLoadMore setRef={setTarget} />
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default GroupTable;
